/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useState } from "react";
import { Box, FlexContainer, theme } from "@nordcloud/gnui";
import { ChartTableSortField } from "~/generated/graphql";
import {
  EstatePeriod,
  Option,
  SearchBoxContainer,
  SortDirection,
} from "~/components";
import { useQueryState } from "~/hooks";
import { EstateChartTableQueryState } from "../Charts/types";
import { EstateSortV2 } from "../EstateSortV2";
import { ExportGroupedResources } from "../ExportGroupedResources";
import { getEndDate, getStartDate } from "../helpers";

type Props = {
  sortField: ChartTableSortField;
  sortDirection: SortDirection;
  sortOptions: Option[];
  onSortSelect: (value: ChartTableSortField) => void;
  onSortDirectionSelect: (direction: SortDirection) => void;
  jobId: string;
  totalRecords: number;
  disabled?: boolean;
};

export function EstateGroupedParametersBar({
  sortField,
  sortDirection,
  sortOptions,
  onSortSelect,
  onSortDirectionSelect,
  disabled,
  jobId,
  totalRecords,
}: Props) {
  const {
    state: { periodStart, periodEnd },
  } = useQueryState<EstateChartTableQueryState>();

  const [searchInput, setSearchInput] = useState("");

  return (
    <>
      <Box boxStyle="lightGrey" marginBottom={theme.spacing.spacing04}>
        <FlexContainer justifyContent="space-between">
          <FlexContainer alignItems="center" wrap="wrap">
            <span
              css={{
                marginRight: theme.spacing.spacing04,
                zIndex: theme.zindex.dropdown,
              }}
            >
              <EstateSortV2<ChartTableSortField>
                sortField={sortField}
                sortDirection={sortDirection}
                options={sortOptions}
                disabled={disabled}
                onSortOrderChange={onSortDirectionSelect}
                onSortSelect={onSortSelect}
              />
            </span>
            <SearchBoxContainer
              searchInput={searchInput}
              width="20rem"
              setSearchInput={setSearchInput}
              disabled={disabled}
            />
          </FlexContainer>
          <FlexContainer>
            <ExportGroupedResources
              recordsCount={totalRecords}
              filters={{
                chartJobId: jobId,
                startDate:
                  periodStart ??
                  getStartDate(EstatePeriod.DEFAULT_MONTH, undefined),
                endDate:
                  periodEnd ??
                  getEndDate(EstatePeriod.DEFAULT_MONTH, undefined),
              }}
            />
          </FlexContainer>
        </FlexContainer>
      </Box>
    </>
  );
}
